/**
 * Visual Blocks Language
 *
 * Copyright 2012 Google Inc.
 * http://blockly.googlecode.com/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Generating JavaScript for procedure blocks.
 * @author fraser@google.com (Neil Fraser)
 */
'use strict';

goog.provide('Blockly.JavaScript.procedures');

goog.require('Blockly.JavaScript');

Blockly.JavaScript.procedures_defreturn = function() {
  var title = this.getTitle_('NAME');
  var functionName;
  if (title.id && this.type === 'behavior_definition') {
    // Sprite Lab shared behaviors use an id field on the title
    // so that we can translate the block text without changing
    // the generated code.
    functionName = title.id;
  } else {
    // If the title doesn't have an id, use the title value
    // as the function name.
    functionName = title.getValue();
  }
  // Define a procedure with a return value.
  var funcName = Blockly.JavaScript.variableDB_.getName(
    functionName,
    Blockly.Procedures.NAME_TYPE
  );
  // Store names for each of the args
  // NOTE: It is important to do this first so the first call to getName()
  // for each arg includes the specific type of NAME_TYPE_LOCAL (local var)
  var args = [];
  for (var x = 0; x < this.parameterNames_.length; x++) {
    args[x] = Blockly.JavaScript.variableDB_.getName(
      this.parameterNames_[x],
      Blockly.Variables.NAME_TYPE,
      Blockly.Variables.NAME_TYPE_LOCAL
    );
  }
  var branch = Blockly.JavaScript.statementToCode(this, 'STACK');
  if (Blockly.JavaScript.INFINITE_LOOP_TRAP) {
    branch =
      Blockly.JavaScript.INFINITE_LOOP_TRAP.replace(
        /%1/g,
        "'" + this.id + "'"
      ) + branch;
  }
  var returnValue =
    Blockly.JavaScript.valueToCode(
      this,
      'RETURN',
      Blockly.JavaScript.ORDER_NONE
    ) || '';
  if (returnValue) {
    returnValue = '  return ' + returnValue + ';\n';
  }
  var code =
    (Blockly.varsInGlobals
      ? 'Globals.' + funcName + ' = function'
      : 'function ' + funcName) +
    '(' +
    args.join(', ') +
    ') {\n' +
    branch +
    returnValue +
    '}';
  code = Blockly.JavaScript.scrub_(this, code);
  Blockly.JavaScript.definitions_[funcName] = code;
  return null;
};

// Defining a procedure without a return value uses the same generator as
// a procedure with a return value.
Blockly.JavaScript.procedures_defnoreturn =
  Blockly.JavaScript.procedures_defreturn;

Blockly.JavaScript.procedures_callreturn = function() {
  // Call a procedure with a return value.
  var funcName = Blockly.JavaScript.variableDB_.getName(
    this.getTitleValue('NAME'),
    Blockly.Procedures.NAME_TYPE
  );
  var args = [];
  for (var x = 0; x < this.currentParameterNames_.length; x++) {
    args[x] =
      Blockly.JavaScript.valueToCode(
        this,
        'ARG' + x,
        Blockly.JavaScript.ORDER_COMMA
      ) || 'null';
  }
  var code =
    (Blockly.varsInGlobals ? 'Globals.' : '') +
    funcName +
    '(' +
    args.join(', ') +
    ')';
  return [code, Blockly.JavaScript.ORDER_FUNCTION_CALL];
};

Blockly.JavaScript.procedures_callnoreturn = function() {
  // Call a procedure with no return value.
  var funcName = Blockly.JavaScript.variableDB_.getName(
    this.getTitleValue('NAME'),
    Blockly.Procedures.NAME_TYPE
  );
  var args = [];
  for (var x = 0; x < this.currentParameterNames_.length; x++) {
    args[x] =
      Blockly.JavaScript.valueToCode(
        this,
        'ARG' + x,
        Blockly.JavaScript.ORDER_COMMA
      ) || 'null';
  }
  var code =
    (Blockly.varsInGlobals ? 'Globals.' : '') +
    funcName +
    '(' +
    args.join(', ') +
    ');\n';
  return code;
};

Blockly.JavaScript.procedures_ifreturn = function() {
  // Conditionally return value from a procedure.
  var condition =
    Blockly.JavaScript.valueToCode(
      this,
      'CONDITION',
      Blockly.JavaScript.ORDER_NONE
    ) || 'false';
  var code = 'if (' + condition + ') {\n';
  if (this.hasReturnValue_) {
    var value =
      Blockly.JavaScript.valueToCode(
        this,
        'VALUE',
        Blockly.JavaScript.ORDER_NONE
      ) || 'null';
    code += '  return ' + value + ';\n';
  } else {
    code += '  return;\n';
  }
  code += '}\n';
  return code;
};
